<template>
    <div :class="{ disabled_item: $props.disabled===true }">
        <div id="mi_theysay_control">
            <div class="left">
                <a @click="toggle" class="pointer"><span>O que as pessoas dizem</span>&nbsp;&nbsp;{{show_title}}</a>
            </div>
        </div>
        <div id="mi_theysay" :class="{active:isShowing}">
            <div id="mi_theysay_add" v-show="isAdding">
                <v-text-field label="Nome" v-model="current.name"></v-text-field>
                <v-text-field label="Cargo" v-model="current.position"></v-text-field>
                <v-textarea
                    label="Comentário"
                    rows="2"
                    auto-grow
                    v-model="current.comment">
                </v-textarea>
                <button class="fluke-btn" @click="add(index != undefined ? index : 'undefined')">Salvar</button>
                <button class="fluke-btn fluke-grey" @click="cancel">Cancel</button>
            </div>
            <div id="mi_theysay_list" v-show="list.length && !isAdding">
				<table>
					<thead>
						<tr>
							<th>Nome</th>
							<th>Cargo</th>
							<th>Comentário</th>
                            <th>&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" v-bind:key="index">
							<td>{{item.name}}</td>
							<td>{{item.position}}</td>
							<td>{{item.comment}}</td>
                            <td class="editCol">
                                <button class="flake-btn" @click="edit_enable(item, index)" v-if="$props.disabled!==true"><i class="material-icons">edit</i></button>
                                <button class="flake-btn" @click="remove(index)" v-if="$props.disabled!==true"><i class="material-icons">delete</i></button>
                            </td>
						</tr>
					</tbody>
				</table>
            </div>
            <div id="mi_theysay_add_button" v-show="!isAdding" v-if="$props.disabled!==true">
                <button class="fluke-btn" @click="add_enable">Adicionar</button>
            </div>
        </div>
    </div>
</template>

<script>
import mi from './mi.js';

export default {
    mixins: [
        mi
    ],
    props: [ 'disabled' ],
    data: function(){
        return {
            current: {
                name: '',
                position: '',
                comment: ''
            }
        }
    },
    methods: {
        add_enable: function()
        {
            this.current = {
                name: '',
                position: '',
                comment: ''
            }
            this.isAdding = true;
            this.index = undefined;
        },
        edit_enable: function(item, index){
            this.current = item;
            this.index = index;
            this.isAdding = true;
        }
    }
}
</script>